import { useCompanyId } from '@startuptools/common/react-wrapper';
import { SccsTableInner } from './SccsTableInner';
import { useSccsTableSuspenseQuery } from './SccsTable.graphql';
import { GqlCurrency, GqlSortOrder } from '../../../graphql/base-types.graphql';
import { useMemo } from 'react';

export const ShareCapitalChangesTable = () => {
  const companyId = useCompanyId();

  const {
    data: { completeSccs, company },
    error,
  } = useSccsTableSuspenseQuery({
    variables: { companyId, sort: GqlSortOrder.Desc },
    fetchPolicy: 'cache-and-network',
  });

  const sums = useMemo(() => {
    return completeSccs.reduce(
      (total, scc) => {
        const currency = scc.currency ?? 'SEK';
        if (!(currency in total)) {
          total[currency] = 0;
        }
        total[currency]! += scc.paidAmount ? scc.paidAmount : 0;
        return total;
      },
      {} as { [k in GqlCurrency]?: number },
    );
  }, [completeSccs]);

  return <SccsTableInner rows={completeSccs} totalPaid={sums} error={error} hasFoundation companyName={company.name} />;
};
